<strong>Edition:</strong>
<div class="btns">
  @for (edition of allEditions; track edition.id) {
  <button
    type="button"
    mat-button
    [class.selected]="currentEdition == edition.name"
    (click)="selectEdition(edition)"
  >
    <span>{{ 'login.editions.' + edition.name | translate }}</span>
    <mat-icon>{{ edition.icon }}</mat-icon>
  </button>
  }
</div>
